/**
 * TIC 세로축 눈금 표기 — 큰 수를 짧게.
 *
 * 2026-09-04 (운영자): "Intensity 의 경우 값이 글자를 덮어서 안 보여."
 *
 * 실측: 세로축 눈금 자리는 **50px** 인데 `1,500,000` 은 그보다 넓어 왼쪽의 축
 * 이름("Intensity") 위로 넘쳤다. 눈금 폭을 늘리면 가뜩이나 좁은 플롯(303px)이
 * 더 좁아지므로, 눈금 쪽을 줄인다.
 *
 * **줄이는 것은 눈금뿐이다.** 커서가 읽는 값은 여전히 원래 숫자 전체다(차트
 * 위 칩) — 증거 화면에서 읽는 값을 반올림해 보여주면 안 된다. 눈금은 "여기가
 * 대략 어느 높이인가"를 말하는 위치 표시이지 판독하는 값이 아니다.
 */
export function compactIntensity(value: number): string {
  if (!Number.isFinite(value)) return "";

  const sign = value < 0 ? "-" : "";
  const size = Math.abs(value);

  if (size >= 1_000_000) return `${sign}${trim(size / 1_000_000)}M`;
  if (size >= 1_000) return `${sign}${trim(size / 1_000)}k`;
  return `${sign}${trim(size)}`;
}

/**
 * 소수 **두 자리**까지, 끝자리 0 은 붙이지 않는다.
 *
 * 한 자리로 줄였더니 1,250,000 눈금이 "1.3M" 으로 표시됐다 — 격자는 1.25M
 * 자리에 있는데 라벨은 1.3M 이라, 눈금 간격을 잘못 읽게 된다(0.25 인데 0.3
 * 으로 보인다). 증거 화면에서 눈금이 실제 위치와 다르게 읽히면 안 된다.
 */
function trim(value: number): string {
  return String(Math.round(value * 100) / 100);
}
